import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DriverOrder, ProductDriverOrder } from '@models';
import { AlertService, SaleOrdersService } from '@services';
import { GetUnitText } from '@utils';

@Component({
  selector: 'digicem-delivery-code-dialog',
  templateUrl: './delivery-code-dialog.component.html',
})
export class DeliveryCodeDialogComponent {
  protected order: DriverOrder;
  protected onAccept: () => void;

  protected isValidCode = false;
  protected code = '';
  protected isLoading = false;
  protected hasError = false;

  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: {
      order: DriverOrder;
      onAccept: () => void;
    },
    private dialog: MatDialogRef<DeliveryCodeDialogComponent>,
    private saleOrdersService: SaleOrdersService,
    private alertService: AlertService,
  ) {
    this.order = data.order;
    this.onAccept = data.onAccept;
  }

  protected onCodeFilled(code: string): void {
    if (this.code === code) {
      return;
    }
    this.hasError = false;
    this.code = code;
    this.isValidCode = code.length === 4;
  }

  protected onCancel(): void {
    this.dialog.close();
  }

  protected onConfirmDelivery(): void {
    if (this.isValidCode && !this.isLoading) {
      this.isLoading = true;
      this.saleOrdersService
        .patchDeliveryCode(this.order.saleOrderId, this.code)
        .subscribe({
          next: () => {
            this.isLoading = false;
            this.onAccept();
            this.dialog.close();
          },
          error: () => {
            this.isLoading = false;
            this.hasError = true;
            this.alertService.showAlert(
              'Código ingresado incorrecto.',
              'critical',
              100,
            );
          },
        });
    }
  }

  protected getQuantityProduct(product: ProductDriverOrder): string {
    return (
      product.quantity +
      ' ' +
      GetUnitText(product.measurementUnit, product.quantity <= 1)
    );
  }

  protected getTitleProduct(index: number): string {
    if (this.order?.products.length === 1) {
      return 'Producto';
    }
    return 'Producto #' + (index + 1).toString();
  }
}
